import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  button:{
    margin: 0,
    padding: 0,
    fontSize: 12,
    color:'blue',
  },
  edit:{
    margin:0,
    padding:0,
    color: theme.palette.orange.main,
    cursor: 'pointer',
    fontSize: 12,
  }
}));
